module.exports = __webpack_public_path__ + "h5/img/up.ba46ce08.png";